import { SITE_TECHNICAL_DATA } from "src/consts/session";

export const calculateYearlyGridSupply = (
  personsInHousehold: number,
  siteTechnicalData?: SITE_TECHNICAL_DATA
) => {
  let baseYearlyGridSupply = 0;
  switch (personsInHousehold) {
    case 1:
      baseYearlyGridSupply = 1500;
      break;
    case 2:
      baseYearlyGridSupply = 2500;
      break;
    case 3:
      baseYearlyGridSupply = 3500;
      break;
    case 4:
      baseYearlyGridSupply = 4250;
      break;
    case 5:
      baseYearlyGridSupply = 5200;
      break;
  }

  let pvFactor = 1;
  const pvInstalled = siteTechnicalData?.pvSetup?.pvInstalled
    ? JSON.parse(siteTechnicalData.pvSetup.pvInstalled)
    : false;
  if (pvInstalled) {
    pvFactor = 0.65;
  }

  let evSupply = 0;
  const wallboxInstalled = siteTechnicalData?.wallboxInstalled
    ? JSON.parse(siteTechnicalData.wallboxInstalled)
    : false;
  if (wallboxInstalled) {
    evSupply = 2000;
  }

  let batteryFactor = 1;
  const batteryInstalled = siteTechnicalData?.batterySetup?.batteryInstalled
    ? JSON.parse(siteTechnicalData.batterySetup.batteryInstalled)
    : false;
  if (pvInstalled && batteryInstalled) {
    batteryFactor = 0.65;
  }

  const yearlyGridSupply =
    (baseYearlyGridSupply + evSupply) * pvFactor * batteryFactor;

  const yearlyGridSupplyTrunc = Math.trunc(yearlyGridSupply);
  const yearlyGridSupplyFloor = Math.floor(yearlyGridSupplyTrunc / 10);
  const yearlyGridSupplyTrailingZero = +(yearlyGridSupplyFloor + "0");

  const yearlyGridSupplyFormatted = new Intl.NumberFormat("de-DE").format(
    yearlyGridSupplyTrailingZero
  );

  return yearlyGridSupplyFormatted;
};
